<template>
  <div class="lowie">
    对不起，您的浏览器版本过低，为了更好的体验，请升级你的浏览器<br/>
    推荐您使用Chrome(谷歌)浏览器或者浏览器选择极速模式
  </div>
</template>
<script>
import { userAgent } from 'ua_parser'
var { browser } = userAgent(navigator.userAgent)
var { name, version } = browser; var { major } = version
export default {
  beforeRouteEnter (to, from, next) {
    next(vm=>{
      vm.$store.dispatch('hideNavbar');
    })
  }
}
</script>
<style lang="scss" scoped>
  @import "../common/theme.scss";
  .lowie {
    text-align: center;
    width: 100%;
    height: 100%;
    color: $themeColor;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>